<template>
  <div class="the-navbar__user-meta flex items-center" v-if="userInfo">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ userInfo }}</p>
      <small>{{ userRole }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img v-if="activeUserInfo.photoURL" key="onlineImg" src="@/assets/images/21104.svg" alt="user-img" width="40" height="40" class="rounded-full bg-primary shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li @click="$router.push('/profile').catch(() => {})" class="flex align-items-center py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-3">Profile</span>
          </li>

          <li @click="toggleLayout(layoutName)" class="flex align-items-center py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <vx-tooltip class="flex align-items-center" text="Switch Layout">
              <feather-icon icon="ToggleLeftIcon" svgClasses="w-4 h-4" /> <span class="ml-3">{{ layoutName }}</span></vx-tooltip
            >
          </li>

          <li @click="backToPatentUser" v-if="allowGoBackToParent" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <vx-tooltip text="Back To Parent User"> <feather-icon icon="UserIcon" svgClasses="w-4 h-4" /> Back To </vx-tooltip>
          </li>

          <vs-divider class="m-1" />

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    allowGoBackToParent() {
      return localStorage.getItem('logInAsMultiLocationUser') !== 'true' && !!localStorage.getItem('MultiLocationUser')
    },
    userInfo() {
      const user = this.$store.state.auth.user
      return `${user.firstname} ${user.lastname}`
    },
    userRole() {
      const user = this.$store.state.auth.user
      return user.role.role_name
    },
    layoutName() {
      return localStorage.getItem('mainLayoutType') ? (localStorage.getItem('mainLayoutType') === 'Vertical' ? 'Horizontal' : 'Vertical') : 'Horizontal'
    }
  },
  methods: {
    async backToPatentUser() {
      try {
        const id = localStorage.getItem('MultiLocationUser')
        const { accessToken } = await this.$store.dispatch('auth/signInAs', parseInt(id))
        localStorage.setItem('accessToken', accessToken)

        this.$router.go()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    toggleLayout(layout) {
      localStorage.setItem('mainLayoutType', layout)
      this.$router.go()
    },

    logout() {
      this.$store.dispatch('auth/logOut')
      localStorage.removeItem('selectedBookMarks')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/').catch(() => {})
    }
  }
}
</script>
